module.exports = __webpack_public_path__ + "static/Antojitos-Yolys-Harlingen-703-N-Ed-Carey-Dr-Harlingen-TX-78550-210e79e64b4634edef16fafe9e919e4e.png";